import React, {
  DetailedHTMLProps,
  ReactNode,
  TextareaHTMLAttributes,
} from 'react'
import clsx from 'clsx'
import { UseFormRegisterReturn } from 'react-hook-form'

type Props = {
  name: string
  label: string
  field?: UseFormRegisterReturn<string>
  contentAtEnd?: ReactNode
  hasError?: boolean
} & DetailedHTMLProps<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
>

export default function TextareaWithFloatingLabel({
  label,
  contentAtEnd,
  hasError,
  field,
  ...props
}: Props) {
  // Name is useful in other places like assigning label
  const { name, value, disabled } = props

  return (
    <div className="relative flex items-center">
      {contentAtEnd && (
        <div className="absolute right-0 pr-4">{contentAtEnd}</div>
      )}
      <textarea
        id={name}
        {...props}
        {...field}
        className={clsx(
          'peer block min-h-[4.5rem] w-full resize-none overflow-auto rounded-2xl border-0 px-4 pb-0 pt-7 text-base text-gray-900 ring-2 ring-inset focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:leading-6',
          hasError ? 'ring-red-600' : 'ring-gray-300',
          disabled ? 'bg-gray-200' : '',
        )}
      />
      <label
        htmlFor={name}
        className={clsx(
          'absolute left-0 top-0 block w-full origin-top-left rounded-2xl pl-4 pt-7 text-base text-gray-400 transition-all duration-300',

          // If the field is not empty, leave the label up top
          value
            ? '-translate-y-3 translate-x-1 scale-75'
            : 'peer-focus:-translate-y-3 peer-focus:translate-x-1 peer-focus:scale-75',
        )}
      >
        {label}
      </label>
    </div>
  )
}
